import { UPDATE_NAVIGATION } from '../redux-action-types'

const initialState = {
  backToListPath: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_NAVIGATION:
      return {
        ...state,
        backToListPath: action.backToListPath
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/navigation-reducer.js